import "./App.css";
import React from "react";
import Booking from "./pages/Booking";
// @ts-ignore
import Login from "./pages/Login";
// @ts-ignore
import Admin from "./pages/Admin";
import {Route, Routes} from "react-router-dom";
// @ts-ignore
import OverView from "./pages/OverView";
// @ts-ignore
import RoleSetting from "./pages/RoleSetting";
import {Authenticated} from "./components/helper/Authenticated";

const App: React.FC = () => {
  return (
    <>
      <Routes>
        <Route path="/" element={<Login/>}/>
        <Route path="/booking" element={
          <Authenticated>
            <Booking/>
          </Authenticated>
        }/>
        <Route path="/admin" element={
          <Authenticated>
            <Admin/>
          </Authenticated>
        }/>
        <Route path="/overview" element={
          <Authenticated>
            <OverView/>
          </Authenticated>
        }/>
        <Route path="/rolesetting" element={
          <Authenticated>
            <RoleSetting/>
          </Authenticated>
        }/>
      </Routes>
    </>
  );
}

export default App;
